/* Text styles */
._RolesView_ax1c3_2 ._table_ax1c3_2 ._nameCell_ax1c3_2 ._avatar_ax1c3_2 {
  margin-right: 10px;
}